/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Tab_MediaInputs */

const cs_projects_tab_media = /** @type {(inputs: Projects_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky a videa`)
};

const en_projects_tab_media = /** @type {(inputs: Projects_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos & videos`)
};

/**
* | output |
* | --- |
* | "Photos & videos" |
*
* @param {Projects_Tab_MediaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_tab_media = /** @type {((inputs?: Projects_Tab_MediaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Tab_MediaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_tab_media(inputs)
	return cs_projects_tab_media(inputs)
});